import React from "react";
import { Link } from "react-router-dom";
import localizationStrings from "../../statics/localization";
import { getCinemaCopy } from "../../statics/cinemaCopy";
import logo from "../../assets/logo/atlas-logo.png";
import { onGuideIntent } from "../../api/ltv/prewarmGuide";
import { useCatalogTheme } from "../cinema/CatalogTheme";
import KidsBrand from "../cinema/KidsBrand";

const Footer = () => {
  const copy = getCinemaCopy();
  const { isKids } = useCatalogTheme();
  return (
    <footer className="footer-container">
      <div className="cinema-footer-main">
        <div className="cinema-footer-brand">
          <Link to="/dashboard" aria-label={isKids ? "Atlas Kids" : undefined}>
            {isKids ? <KidsBrand /> : <img src={logo} alt="Atlas" />}
          </Link>
        </div>
        <nav
          className="cinema-footer-links"
          aria-label={localizationStrings.quicklinks}
        >
          <Link to="/dashboard">{localizationStrings.home}</Link>
          <Link to="/dashboard/livetv/all">{copy.live}</Link>
          <Link
            to="/dashboard/tvguide"
            onMouseEnter={onGuideIntent}
            onFocus={onGuideIntent}
            onTouchStart={onGuideIntent}
          >
            {copy.guide}
          </Link>
          <Link to="/dashboard/settings">{localizationStrings.settings}</Link>
        </nav>
      </div>
      <div className="cinema-footer-bottom">
        <span>
          {localizationStrings.footer.copyright.replace(
            "{year}",
            new Date().getFullYear()
          )}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
